export default "__VITE_ASSET__4YMvqMtI__"